import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-white" data-id="element-41" data-mp="1nwvvgvzfmdp8">
      <div className="mx-auto max-w-2xl px-4 py-6 sm:px-6 sm:py-8" data-id="element-42" data-mp="2blf45cme8shu">
        <SectionHeading id="faq" title="Preguntas frecuentes" data-id="element-43" data-mp="2flpibckcap7s" />

        <div className="mt-3 space-y-1.5" data-id="element-44" data-mp="2fo1z3med2tj9">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-xl bg-mist" data-id="element-45" data-mp="26t40byoj8mk0" data-mpi={i}>
                <h3 data-id="element-46" data-mp="26ratojdx62c0">
                  <button type="button" id={`faq-button-${i}`} onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 rounded-xl px-3.5 py-2.5 text-left" data-id="element-47" data-mp="2ujhvvz6bt3jc">
                    <span className="font-display text-sm font-bold text-navy" data-id="element-48" data-mp="25faxectv10m0">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} aria-hidden="true" className={`shrink-0 text-navy transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-49" data-mp="20o2mtdgsn979" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-50" data-mp="2jfln3cjfo95l">
                  {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-button-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-51" data-mp="2jdj0l2hhoy5m">
                      <p className="px-3.5 pb-2.5 text-[0.8rem] leading-snug text-graphite-muted sm:text-sm" data-id="element-52" data-mp="2z3uludfq0qyg">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}